import { useState } from 'react';
import { Select, Spin } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { accountsApi } from '../../api/endpoints/accounts';

interface AccountSelectProps {
  value?: number | null;
  onChange?: (value: number | undefined) => void;
  placeholder?: string;
  allowClear?: boolean;
}

/** Autocomplete que busca cuentas en el servidor (debounced). */
export function AccountSelect({
  value,
  onChange,
  placeholder = 'Buscar cuenta…',
  allowClear = true,
}: AccountSelectProps): JSX.Element {
  const [search, setSearch] = useState('');

  const { data, isFetching } = useQuery({
    queryKey: ['accounts', 'lookup', search],
    queryFn: () =>
      accountsApi.list({ page: 1, pageSize: 20, search: search || undefined, sortDir: 'asc' }),
  });

  const options =
    data?.data.map((a) => ({
      label: a.name,
      value: a.id,
    })) ?? [];

  return (
    <Select
      showSearch
      allowClear={allowClear}
      placeholder={placeholder}
      value={value ?? undefined}
      onChange={(v) => onChange?.(v ?? undefined)}
      onSearch={setSearch}
      filterOption={false}
      notFoundContent={isFetching ? <Spin size="small" /> : 'Sin resultados'}
      options={options}
      style={{ width: '100%' }}
    />
  );
}
